import type { GameAction, GamePhase } from "@fate-kingdom/engine";

export interface AlphaAutoProgression {
  readonly action: Extract<GameAction, { readonly type: "advance-phase" }>;
  readonly message: string;
  readonly delayMs: number;
}

export function getAlphaAutoProgression({
  phase,
  legalActions,
  canProgress,
}: {
  readonly phase: GamePhase;
  readonly legalActions: readonly GameAction[];
  readonly canProgress: boolean;
}): AlphaAutoProgression | null {
  if (!canProgress || legalActions.length !== 1 || legalActions[0]?.type !== "advance-phase") {
    return null;
  }
  const action = legalActions[0];
  switch (phase) {
    case "ready":
      return { action, message: "Ready resolved. Drawing your hand…", delayMs: 120 };
    case "draw":
      return { action, message: "Draw resolved. Choose a Land to begin.", delayMs: 120 };
    case "land":
      return { action, message: "Land established. Continuing to Supply…", delayMs: 180 };
    case "supply":
      return { action, message: "Supply resolved. Continuing to Command…", delayMs: 260 };
    default:
      return null;
  }
}
